module.exports = __webpack_public_path__ + "static/media/Logo.343f5259.webp";